import React from 'react'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTATheme } from 'marketing-site/src/library/utils'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { EditorialStoryGrid } from 'marketing-site/src/library/components/EditorialStoryGrid'
import { IEditorialStories } from './index'
import { MagicLine } from 'marketing-site/src/library/components/MagicLine'

import styles from './styles-legacy.scss'

import { EditorialStories as EditorialStoriesDefault } from './component'
import { NewBrandingHoc } from 'marketing-site/src/library/utils/NewBrandingHoc'

const EditorialStoriesLegacy = (props: IEditorialStories): React.ReactElement | null => {
  const renderMagicLine = () =>
    props.includeMagicLine && (
      <MagicLine
        containerHeight={0}
        topOverlappingSize="250px"
        minWidth="238px"
        minHeight="238px"
      />
    )

  if (!props.customerStoryGrid) return null

  return (
    <>
      <div className="customer__story-wrap">
        <div className="customer__story">
          {props.headline && (
            <h2 className="customer__story-header">
              <Text size="xxl+">{props.headline}</Text>
              {props.slug && (
                <div className="customer__story-viewall">
                  <CTALink
                    url={props.slug}
                    bgColor={CTATheme.LinkOnlyBlack}
                    text="View all"
                    arrow={true}
                  />
                </div>
              )}
            </h2>
          )}
          <div className="customer__story-grid">
            <EditorialStoryGrid {...props.customerStoryGrid} asFullGrid />
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
      {renderMagicLine()}
    </>
  )
}

export const EditorialStories = NewBrandingHoc(EditorialStoriesLegacy, EditorialStoriesDefault)
